(() => {
  for (const root of document.querySelectorAll('[data-sh-category-carousel]')) {
    if (root.dataset.ready === 'true') continue;
    const index = JSON.parse(root.querySelector('[data-sh-category-index]').textContent);
    const titles = JSON.parse(root.querySelector('[data-sh-category-titles]').textContent);
    for (const [key, title] of Object.entries(titles)) if (index[key]) index[key].title = title;
    const handle = new URL(location.href).searchParams.get('sh_collection') || root.dataset.handle;
    const children = index[handle]?.children || [];
    if (!children.length) continue;
    const track = root.querySelector('[data-sh-category-track]');
    const controls = root.querySelector('[data-sh-category-controls]');
    const previous = root.querySelector('[data-sh-category-previous]');
    const next = root.querySelector('[data-sh-category-next]');
    for (const key of children) {
      const child = index[key];
      if (!child) continue;
      const link = document.createElement('a');
      link.className = 'shcc-card';
      const destination = new URL(root.dataset.catalogRoot + 'collections/' + key, location.origin);
      if (root.dataset.review === 'true') {
        destination.pathname = root.dataset.catalogRoot + 'pages/marcas';
        destination.searchParams.set('view', 'sh-catalog-review');
        destination.searchParams.set('sh_collection', key);
        destination.searchParams.set('preview_theme_id', '210099241297');
        destination.searchParams.set('pb', '0');
        if (handle === 'osprey') destination.searchParams.set('filter.p.vendor', 'Osprey');
      }
      link.href = destination.href;
      const visual = document.createElement('span');
      visual.className = 'shcc-image';
      const image = document.createElement('img');
      const source = new URL(child.image, location.origin);
      source.searchParams.set('width', '600');
      image.src = source.href;
      image.width = 600;
      image.height = 600;
      image.alt = '';
      image.loading = 'lazy';
      visual.append(image);
      const label = document.createElement('span');
      label.className = 'shcc-label';
      label.textContent = child.title;
      link.append(visual, label);
      track.append(link);
    }
    if (!track.children.length) continue;
    root.hidden = false;
    const update = () => {
      const maximum = track.scrollWidth - track.clientWidth;
      controls.hidden = maximum < 4;
      previous.disabled = track.scrollLeft <= 4;
      next.disabled = track.scrollLeft >= maximum - 4;
    };
    const scroll = direction => {
      track.scrollBy({left: direction * track.clientWidth * .8, behavior: matchMedia('(prefers-reduced-motion: reduce)').matches ? 'instant' : 'smooth'});
    };
    previous.addEventListener('click', () => scroll(-1));
    next.addEventListener('click', () => scroll(1));
    track.addEventListener('scroll', update, {passive: true});
    new ResizeObserver(update).observe(track);
    root.dataset.ready = 'true';
    update();
  }
})();

